import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.DEVICES,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/DevicesContainer'),
      import('./reducers')
    ])
    injectReducer(store, { key: 'myDevices', reducer: reducer.default })

    cb(null, module.default)
  }
})
